module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/xfztE6/images/cover.jpg?1684979252503",
      "alt": "This image is the cover for the book Sacred Misinterpretation"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Sacred Misinterpretation\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('i', [_vm._v("Promotes gracious interfaith dialogue on sensitive theological issues")])]), _c('p', [_vm._v("Theological issues are crucial to how Christians and Muslims understand and perceive each other. In "), _c('i', [_vm._v("Sacred Misinterpretation ")]), _vm._v("Martin Accad guides readers through key theological questions that fuel conflict and misunderstanding between Muslims and Christians. A sure-footed guide, he weaves personal stories together with deep discussion of theological beliefs.")]), _vm._v("Accad identifies trends, recognizes historical realities, and brings to light significant points of contention that often lead to break-down in Christian-Muslim dialogue. He also outlines positive and creative trends that could lead to a more hopeful future. Fairly and seriously presenting both Muslim theology and a Muslim interpretation of Christian theology, "), _c('i', [_vm._v("Sacred Misinterpretation ")]), _vm._v("is an essential guide for fostering dialogue and understanding among readers from both faiths.\n    "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Martin Accad, Gabriel Said Reynolds\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    William B. Eerdmans Publishing Company\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0